import type { InjectionKey, Ref } from "vue";

export type SmxFormLabelPosition = "left" | "top";

export interface SmxFormLayout {
  labelPosition: Readonly<Ref<SmxFormLabelPosition>>;
}

export const smxFormLayoutKey: InjectionKey<SmxFormLayout> =
  Symbol("smxFormLayout");
